import ContactUs from "./ContactPageContent";
import { PageMeta, BreadcrumbJsonLd } from "../seo";

function ContactPage() {
  return (
    <>
      <PageMeta
        title="查詢訂銷"
        description="聯絡貓山王朝｜WhatsApp +852 98312915｜榴槤批發零售查詢、預訂、送貨詳情。"
        canonicalPath="/contact"
      />
      <BreadcrumbJsonLd
        items={[
          { name: "首頁", path: "/" },
          { name: "查詢訂銷", path: "/contact" },
        ]}
      />
      <ContactUs />
    </>
  );
}

export default ContactPage;
